import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import { FluentProvider, teamsLightTheme, teamsDarkTheme } from '@fluentui/react-components';

import store from "./store"

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <FluentProvider theme={teamsLightTheme}>
        <App />
      </FluentProvider>
    </BrowserRouter>
  </Provider>
)

ReactDOM.render(app, document.getElementById("root"))
serviceWorker.unregister()
